import { Picture, TextVerticalSpacer, theme } from '@superhi/design'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
`

export const BackgroundImage = styled(Picture)`
  background-color: ${theme.colors.YELLOW_40};
  position: absolute;
  top: 0;
  z-index: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const Header = styled(TextVerticalSpacer).attrs({ level: '1' })`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`
